import { cloneVacancy } from '../images/clone_vacancy';
import { newVacancy } from '../images/new_vacancy';
import { quickVacancy } from '../images/quick_vacanvy';

export const _newVacancy = {
  img: newVacancy,
  altImg: 'Formulario para la creacion de una nueva vacante.',
  title: 'Nueva vacante',
  text: 'Crea una nueva vacante desde cero y personaliza todos los campos según tu búsqueda.',
  buttons: [
    {
      message: 'Crear nueva vacante',
      category: 'tertiaryGreen',
      size: 'medium',
      icon: null
    }
  ]
};

export const _quickVacanvy = {
  img: quickVacancy,
  altImg: 'Formulario para la creacion rapida de una nueva.',
  title: 'Vacante rápida',
  text: 'Crea una vacante completando menos cantidad de campos y de forma más rápida.',
  buttons: [
    {
      message: 'Crear vacante rápida',
      category: 'tertiaryGreen',
      size: 'medium',
      icon: null
    }
  ]
};

export const _cloneVacancy = {
  img: cloneVacancy,
  altImg: 'Formulario para la creacion de una nueva vacante a partir de una vacante existente.',
  title: 'Copiar una vacante existente',
  text: 'Selecciona una vacante existente para copiar todos sus datos. Podrás editar los que desees.',
  buttons: [
    {
      message: 'Copiar vacante',
      category: 'tertiaryGreen',
      size: 'medium',
      icon: null
    }
  ]
};

export const job = [
  {
    id: 1,
    label: 'Full-time',
    value: 1
  },
  {
    id: 2,
    label: 'Pasantía',
    value: 2
  },
  {
    id: 3,
    label: 'Part-time',
    value: 3
  },
  {
    id: 4,
    label: 'Freelance',
    value: 4
  },
  {
    id: 5,
    label: 'Practica',
    value: 5
  },
  {
    id: 6,
    label: 'Eventual',
    value: 6
  }
];

export const searchReason = [
  {
    label: 'No especificado',
    value: 0
  },
  {
    label: 'Nueva posición creada',
    value: 1
  },
  {
    label: 'Ampliación de dotación',
    value: 2
  },
  {
    label: 'Licencia o Vacaciones',
    value: 3
  },
  {
    label: 'Vacante por renuncia',
    value: 4
  },
  {
    label: 'Desvinculación de personal',
    value: 5
  },
  {
    label: 'Vacante por promoción interna',
    value: 6
  },
  {
    label: 'Vacante por jubilación de personal',
    value: 7
  },
  {
    label: 'Finalización de pasantía',
    value: 8
  },
  {
    label: 'Reubicación de personal',
    value: 9
  },
  {
    label: 'Posición Eventual',
    value: 10
  },
  {
    label: 'Vacante por efectivización de un pasante/eventual',
    value: 11
  }
];

export const _typeOfVacancy = {
  complete: 1,
  fast: 2
};

export const _modality = [
  { id: 1, label: 'Presencial', value: 1 },
  { id: 2, label: 'Remoto', value: 2 },
  { id: 3, label: 'Híbrido', value: 3 }
];

export const _gender = [
  { id: 'F', label: 'Femenino', value: 'F' },
  { id: 'M', label: 'Masculino', value: 'M' },
  { id: null, label: 'No especificado', value: null }
];

export const _statusTest = [
  { id: '1', label: 'Activo', value: '1' },
  { id: 'Ninguno', label: 'No activo', value: 'Ninguno' }
];

export const _statusBatteries = [
  { id: 1, label: 'Activo', value: 1 },
  { id: 0, label: 'No activo', value: 0 }
];

export const _optionPublish = {
  publish: 1,
  noPublish: 2,
  confidential: 3
};

export const _searchType = {
  interna: 'interna',
  externa: 'externa',
  general: 'general'
};

export const _language = [
  { id: 'ale', label: 'Alemán', value: 'ale' },
  { id: 'chi', label: 'Chino', value: 'chi' },
  { id: 'cor', label: 'Coreano', value: 'cor' },
  { id: 'esp', label: 'Español', value: 'esp' },
  { id: 'fra', label: 'Francés', value: 'fra' },
  { id: 'hol', label: 'Holandés', value: 'hol' },
  { id: 'eng', label: 'Inglés', value: 'eng' },
  { id: 'ita', label: 'Italiano', value: 'ita' },
  { id: 'jap', label: 'Japonés', value: 'jap' },
  { id: 'por', label: 'Portugués', value: 'por' },
  { id: 'que', label: 'Quechua', value: 'que' }
];

export const _salaryType = [
  { id: 'bruto', label: 'Bruto', value: 'bruto' },
  { id: 'neto', label: 'Neto', value: 'neto' }
];

export const _timeAvailability = [
  { id: 1, label: 'Mañana', value: 'Mañana' },
  { id: 2, label: 'Tarde', value: 'Tarde' },
  { id: 3, label: 'Noche', value: 'Noche' },
  { id: 4, label: 'Full-time', value: 'Full-time' }
];

export const _nivelLanguage = [
  { value: 9, label: 'Básico' },
  { value: 11, label: 'Intermedio' },
  { value: 10, label: 'Avanzado' },
  { value: 12, label: 'Nativo' }
];

export const _radioType = {
  optional: 2,
  mandatory: 1,
  disabled: 0
};

export const _disabledRadio = [
  'url_perfil',
  'firstname',
  'lastname',
  'born',
  'dni',
  'gender',
  'nationality',
  'locality',
  'date_birth',
  'address',
  'phone',
  'phone2',
  'language',
  'school',
  'educ',
  'jobs',
  'attached_file',
  'social_networks',
  'available_time',
  'remuneration',
  'relocation',
  'legacy',
  'known',
  'handicapped'
];

export const fieldPersonal = [
  'mail',
  'url_perfil',
  'firstname',
  'lastname',
  'born',
  'dni',
  'gender',
  'nationality',
  'locality',
  'date_birth',
  'address',
  'phone',
  'phone2',
  'handicapped'
];

export const fieldProfesional = [
  'language',
  'school',
  'educ',
  'jobs',
  'attached_file',
  'social_networks',
  'available_time',
  'remuneration',
  'relocation',
  'legacy',
  'known'
];

// Esto va a tener que cambiar
export const supportModal = [
  { label: '¿Cómo postular a un empleo?', value: '¿Cómo postular a un empleo?' },
  {
    label: 'Reportar error al completar formulario postulación',
    value: 'Reportar error al completar formulario postulación'
  },
  { label: 'Reportar inconveniente con el Captcha', value: 'Reportar inconveniente con el Captcha' },
  { label: 'Otros', value: 'Otros' },
  {
    label: 'Reportar inconveniente en la carga de mis datos personales',
    value: 'Reportar inconveniente en la carga de mis datos personales'
  },
  {
    label: 'Reportar inconveniente en la carga de mi educación',
    value: 'Reportar inconveniente en la carga de mi educación'
  },
  {
    label: 'Reportar inconveniente en la carga de mis idiomas',
    value: 'Reportar inconveniente en la carga de mis idiomas'
  },
  {
    label: 'Reportar inconveniente en la carga de mi experiencia laboral',
    value: 'Reportar inconveniente en la carga de mi experiencia laboral'
  },
  {
    label: 'Reportar inconveniente en la carga de mi currículum',
    value: 'Reportar inconveniente en la carga de mi currículum'
  },
  {
    label: 'Reportar inconveniente en la carga de mis respuestas en las preguntas obligatorias',
    value: 'Reportar inconveniente en la carga de mis respuestas en las preguntas obligatorias'
  }
];
